export enum EnvironmentType {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
  EMULATOR = 'emulator',
}

export interface ConfigType {
  FIREBASE_URL?: string; // here you need to add all of the configuration for the firebase
  ENVIRONMENT: EnvironmentType;
  API_KEY: string;
  AUTH_DOMAIN: string;
  PROJECT_ID: string;
  STORAGE_BUCKET: string;
  MESSAGING_SENDER_ID: string;
  APP_ID: string;
  RECAPTCHA_KEY: string;
  FIREBASE_APPCHECK_DEBUG_TOKEN?: string;
  MEASUREMENT_ID?: string;
}
